// extracted by mini-css-extract-plugin
module.exports = {"content":"_4e5f713ae4--content--tHuub","builder":"_4e5f713ae4--builder--xsvmw","name":"_4e5f713ae4--name--RP8jG","footer":"_4e5f713ae4--footer--ur2Oi"};